import type { PreferredLanguage } from "@/models/languages";
import type { Transcription } from "@/store/types";
import { selectTranscription } from "@/utils";
import { sanitizeHtmlForDisplay } from "@/utils/sanitizeHtmlForDisplay";

type Props = {
  preferredLanguage: PreferredLanguage;
  transcriptions: Transcription[];
};
export default function RichTranscript({ preferredLanguage, transcriptions }: Props) {
  const { simpleHtml, richTranscript, textTranscript } = selectTranscription(preferredLanguage, transcriptions);
  const activeTranscript = simpleHtml ?? richTranscript ?? textTranscript;
  const __html = sanitizeHtmlForDisplay(activeTranscript?.transcriptionContent ?? "");
  return (
    <div
      style={{
        whiteSpace: "pre-line",
        wordBreak: "break-word",
      }}
      dangerouslySetInnerHTML={{
        __html,
      }}
    />
  );
}
